import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const STTDuration = ({ remainingSeconds = 0, isMobile = false }) => {
  const { t } = useTranslation();
  const formatSTTDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const formatNumber = (num) => String(num).padStart(2, '0');

    return `${formatNumber(hours)} ${t('hours')} ${formatNumber(minutes)} ${t(
      'minutesV2',
    )} ${formatNumber(secs)} ${t('secondsV2')}`;
  };

  return (
    <Typography
      component="span"
      sx={{
        fontSize: isMobile ? '14px' : '16px',
        fontWeight: 700,
        lineHeight: isMobile ? '20px' : '24px',
        color: '#000000',
      }}
    >
      {formatSTTDuration(remainingSeconds)}
    </Typography>
  );
};

export default STTDuration;
